package com.mshopsas.enterprise.aiw.scan.screens.tutorial.intro

import com.mshopsas.enterprise.aiw.scan.screens.commons.base.ViewEvent
import com.mshopsas.enterprise.aiw.scan.screens.commons.base.ViewSideEffect
import com.mshopsas.enterprise.aiw.scan.screens.commons.base.ViewState

class IntroContract {

    sealed interface Event : ViewEvent {
        data object OnInit : Event

        data object OnNextClick : Event
    }

    data class State(
        val isLoading: Boolean
    ) : ViewState

    sealed interface Effect : ViewSideEffect {

        sealed interface Navigation : Effect {
            data object ToGuide : Navigation
            data object ToHome : Navigation
            data object ToPayments : Navigation
            data class ToAudit(val auditCode: String) : Navigation
        }
    }
}
